'use strict';
var formInputs = document.querySelectorAll('form input');
function capitalize(text) {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
}
formInputs.forEach(function(input) {
    var nameValue = input.name;
    var formattedText = capitalize(nameValue);
    input.placeholder = formattedText;
    var label = document.createElement('label');
    label.classList.add('field-label');
    label.setAttribute('for', input.id);
    label.textContent = formattedText;
    input.parentElement.prepend(label);
});

//# sourceMappingURL=js_task_fix_form_DOM.e5afebdd.js.map
